import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import usePreviousValue from '../../hooks/usePreviousValue';

const WizardSlider = ({ children }) => {
  const stepNames = useSelector((state) => state.onboarding.stepNames);
  const currentStep = useSelector((state) => state.onboarding.currentStep);
  const currentStepIndex = stepNames.findIndex(step => step === currentStep);
  const previousStepIndex = usePreviousValue(currentStepIndex);
  const slideDirection = useMemo(() => (previousStepIndex <= currentStepIndex ? 'slide-forward' : 'slide-backward'), [currentStepIndex, previousStepIndex]);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={currentStep}
        timeout={{
          appear: 0,
          enter: 250,
          exit: 150,
        }}
        addEndListener={(node, done) => {
          node.addEventListener('transitionend', done, false);
        }}
        classNames={slideDirection}
      >
        <>{children}</>
      </CSSTransition>
    </SwitchTransition>
  )
}

export default WizardSlider
